<template>
  <div >
    <HeaderLanding></HeaderLanding>
    <b-container fluid class="mt-5 mb-5" style="min-height: 65vh;" >
      <b-row align-h="center">
        <b-col cols="12" md="4">
          <b-form @submit.event.prevent="submitForgotPassword">
            <b-nav pills class="mb-5 justify-content-center nav-signin" >
              <b-nav-item href="/#/register">Register</b-nav-item>
              <b-nav-item active>Log In</b-nav-item>
            </b-nav>
            <h4 class="font-weight-bolder mb-4">Forgot Password</h4>
            <b-form-group
              id="input-group-1"
              class="mb-4 w-100"
            >
              <b-form-input
                id="input-1"
                v-model="$v.input.email.$model"
                :state="validateState('email')"
                type="email"
                placeholder="Enter email"
                aria-describedby="input-email-feedback"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-email-feedback"
                class="text-left"
              >This is a required field and must be a valid email.</b-form-invalid-feedback>
            </b-form-group>

            <b-button type="submit" variant="primary" class="btn-block">Submit</b-button>
            <div class="border-bottom border-dark mb-3" style="margin-top:89px"></div>
            <p class="text-center">Download MusicVerse. Your one-stop app for sacred music</p>
            <b-row class="justify-content-center align-items-center flex-column flex-sm-row">
              <a :href="appStoreUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="App Store" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/applestore-logo.png" class="content-logo" alt="App Store">
              </a>
              <a :href="googlePlayUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="Google Play" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/googleplay-logo.png" class="content-logo" alt="Google Play">
              </a>
              <a :href="appGalleryUrl" class="mt-3 mt-xl-0 content-logo radius" aria-label="App Gallery" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/huawei-logo.png" class="content-logo radius" alt="App Gallery">
              </a>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <FooterLanding></FooterLanding>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import Vue from "vue";
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from "vuelidate";
import { required, minLength,email,sameAs } from "vuelidate/lib/validators";
import HeaderLanding from '../components/HeaderLanding';
import FooterLanding from '../components/FooterLanding';
export default {
  name: 'ForgotPassword',
  mixins: [validationMixin],
  data: () => ({
    input: {
      email: '',
    },
    appStoreUrl: process.env.VUE_APP_ALL_BUTTON_LINK_IOS || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    googlePlayUrl: process.env.VUE_APP_ALL_BUTTON_LINK_ANDROID || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    appGalleryUrl: 'https://appgallery.huawei.com/#/app/C104486453',
  }),
  validations: {
    input: {
      email: {
        email,required
      },
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
  },
  watch: {

  },
  methods: {
    ...mapActions('NotificationModule', ['resetMessage']),
    ...mapActions('AuthModule', ['requestForgotPassword']),
    validateState(name) {
      const {$dirty, $error} = this.$v.input[name];
      return $dirty ? !$error : null;
    },
    async submitForgotPassword() {
      try {
        this.$v.input.$touch();
        if (this.$v.input.$anyError) {
          return;
        }
        const res = await this.requestForgotPassword(this.input.email);
        if (!!res) {
          Vue.swal('Email Sent',res.message,'success')
        }else{
          Vue.swal('Error',this.getMessage,'error')
        }
        this.$v.$reset();
        this.input.email = '';
      } catch (err) {
        // eslint-disable-next-line no-console
        Vue.swal('Error','Something Wrong. Please Try Again','error')
      }
    },

  },
  components: {
    HeaderLanding,FooterLanding
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue